import { render, staticRenderFns } from "./TopicPageController.vue?vue&type=template&id=3169d576&functional=true&"
import script from "./TopicPageController.vue?vue&type=script&lang=js&"
export * from "./TopicPageController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports